export enum ErrorType {
  NetworkError = 'NETWORK_ERROR',
}
